var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "headlines-container" },
    [
      _vm.category === "BettingHeadlines" &&
      _vm.currentBoNavigationHeadlines &&
        _vm.currentBoNavigationHeadlines.length > 0
        ? _c("v-container", { class: ["headlines"], attrs: { fluid: "" } }, [
            _vm.tiles
              ? _c(
                  "div",
                  {
                    ref: "headline-tiles",
                    staticClass: "headline-tiles to-left"
                  },
                  [
                    _c("div", { staticClass: "controls" }, [
                      _c(
                        "span",
                        {
                          staticClass: "button left",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.headlineTilesScroll("left")
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_back_ios")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "button right",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.headlineTilesScroll("right")
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("arrow_forward_ios")])],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "headline-tiles-scroll-container",
                        staticClass: "scroll-container"
                      },
                      [
                        _vm._l(_vm.currentBoNavigationHeadlines, function(
                          headline,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              ref: "headline-tiles-item",
                              refInFor: true,
                              staticClass: "item",
                              class: {
                                couponHeadline: _vm.isHeadlineCoupon(
                                  headline.location
                                )
                              },
                              style: [
                                headline.imageurl
                                  ? {
                                      backgroundImage:
                                        "url(" +
                                        _vm.mediaServer(headline.imageurl) +
                                        ") !important"
                                    }
                                  : ""
                              ],
                              on: {
                                click: function() {
                                  _vm.goToHeadlineLink(headline)
                                  _vm.sendGTMEventBanner({
                                    headline: headline,
                                    index: index
                                  })
                                }
                              }
                            },
                            [
                              _vm.isHeadlineCoupon(headline.location)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "headline-coupon",
                                      class: {
                                        "no-background": !headline.imageurl
                                      }
                                    },
                                    [
                                      _c("market-group", {
                                        attrs: {
                                          idfwmarketgroup: headline.location,
                                          isheadlinecoupon: true,
                                          headline: {
                                            headline: headline,
                                            index: index
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticStyle: {
                            flex: "0 0 1px",
                            height: "165px",
                            background: "transparent"
                          }
                        })
                      ],
                      2
                    )
                  ]
                )
              : _c("div", [
                  !_vm.mobileBigAndBelow
                    ? _c(
                        "div",
                        { staticClass: "headline-big" },
                        [
                          _c(
                            "v-carousel",
                            {
                              style: { height: this.carouselHeight },
                              attrs: {
                                interval: _vm.rotationInterval,
                                cycle: _vm.cycleRotation,
                                "hide-delimiters":
                                  _vm.brandLayout === "generic" ||
                                  _vm.brandKey === "sb" ||
                                  _vm.brandKey === "qcasino"
                              }
                            },
                            _vm._l(_vm.currentBoNavigationHeadlines, function(
                              headline,
                              index
                            ) {
                              return _c(
                                "v-carousel-item",
                                {
                                  key: index,
                                  class: [
                                    {
                                      active:
                                        headline.idfwheadline ===
                                        _vm.selectedTab.idfwheadline
                                    },
                                    {
                                      "hover-headline":
                                        typeof headline.location !==
                                          "undefined" &&
                                        headline.location !== null
                                    }
                                  ],
                                  staticStyle: {
                                    height: "auto",
                                    "min-height": "280px"
                                  },
                                  attrs: {
                                    src: headline.imageurl
                                      ? _vm.mediaServer(headline.imageurl)
                                      : ""
                                  },
                                  on: { notify: _vm.setIndex },
                                  nativeOn: {
                                    click: function($event) {
                                      return function() {
                                        _vm.goToHeadlineLink(headline)
                                        _vm.sendGTMEventBanner({
                                          headline: headline,
                                          index: index
                                        })
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _vm.isHeadlineCoupon(headline.location)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "headline-coupon",
                                          class: {
                                            "no-background": !headline.imageurl
                                          }
                                        },
                                        [
                                          _c("market-group", {
                                            attrs: {
                                              idfwmarketgroup:
                                                headline.location,
                                              isheadlinecoupon: true,
                                              headline: {
                                                headline: headline,
                                                index: index
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mobileBigAndBelow
                    ? _c(
                        "div",
                        { staticClass: "headline-mobile" },
                        [
                          _c(
                            "v-carousel",
                            {
                              class: { mobile: _vm.mobile },
                              staticStyle: { "min-height": "200px" },
                              style: { height: this.carouselHeight },
                              attrs: {
                                "hide-delimiters":
                                  _vm.brandLayout === "generic" ||
                                  _vm.brandKey === "sb" ||
                                  _vm.brandKey === "qcasino",
                                "hide-controls": _vm.brandKey !== "sb"
                              }
                            },
                            _vm._l(_vm.currentBoNavigationHeadlines, function(
                              headline,
                              index
                            ) {
                              return _c(
                                "v-carousel-item",
                                {
                                  key: index,
                                  attrs: {
                                    src: headline.imageurl
                                      ? _vm.mediaServer(headline.imageurl)
                                      : ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return function() {
                                        _vm.goToHeadlineLink(headline)
                                        _vm.sendGTMEventBanner({
                                          headline: headline,
                                          index: index
                                        })
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _vm.isHeadlineCoupon(headline.location)
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "headline-coupon",
                                          class: {
                                            "no-background": !headline.imageurl
                                          }
                                        },
                                        [
                                          _c("market-group", {
                                            attrs: {
                                              idfwmarketgroup:
                                                headline.location,
                                              isheadlinecoupon: true,
                                              headline: {
                                                headline: headline,
                                                index: index
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isRootSportsNavigation &&
      (_vm.brandLayout === "generic" ||
        _vm.brandKey === "sb" ||
        _vm.brandKey === "mav" ||
        _vm.brandKey === "qcasino") &&
      _vm.category === "BettingHeadlines" &&
      (!_vm.currentBoNavigationHeadlines ||
        _vm.currentBoNavigationHeadlines.length === 0)
        ? _c("div", [_c("sports-breadcrumb")], 1)
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "SidebarBanners" &&
      _vm.currentBoNavigationHeadlines &&
        _vm.currentBoNavigationHeadlines.length > 0
        ? _c(
            "v-container",
            {
              class: [_vm.brandKey !== "qcasino" ? "headlines" : "sidebanner"],
              attrs: { fluid: "" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "headline-big",
                  class: [
                    _vm.isReadOnly ? "sidebarbannersRobo" : "sideBanersGeneric"
                  ]
                },
                [
                  _c(
                    "v-carousel",
                    {
                      style: { height: this.carouselHeight },
                      attrs: {
                        interval: _vm.rotationInterval,
                        "hide-delimiters": "",
                        cycle: _vm.cycleRotation,
                        "hide-controls": ""
                      }
                    },
                    _vm._l(_vm.currentBoNavigationHeadlines, function(
                      headline,
                      index
                    ) {
                      return _c("v-carousel-item", {
                        key: index,
                        class: [
                          {
                            active:
                              headline.idfwheadline ===
                              _vm.selectedTab.idfwheadline
                          },
                          {
                            "hover-headline":
                              typeof headline.location !== "undefined" &&
                              headline.location !== null
                          }
                        ],
                        staticStyle: { height: "auto" },
                        attrs: {
                          src: headline.imageurl
                            ? _vm.mediaServer(headline.imageurl)
                            : ""
                        },
                        on: { notify: _vm.setIndex },
                        nativeOn: {
                          click: function($event) {
                            return function() {
                              _vm.goToHeadlineLink(headline)
                              _vm.sendGTMEventBanner({
                                headline: headline,
                                index: index
                              })
                            }.apply(null, arguments)
                          }
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "WelcomeBanner" &&
      _vm.currentBoNavigationHeadlines &&
        _vm.currentBoNavigationHeadlines.length > 0
        ? _c("v-container", { class: ["headlines"], attrs: { fluid: "" } }, [
            _c(
              "p",
              {
                class: {
                  "hover-headline":
                    typeof _vm.currentBoNavigationHeadlines[0].location !==
                      "undefined" &&
                    _vm.currentBoNavigationHeadlines[0].location !== null
                },
                on: {
                  click: function($event) {
                    return _vm.goToHeadlineLink(
                      _vm.currentBoNavigationHeadlines[0]
                    )
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.mediaServer(
                      _vm.currentBoNavigationHeadlines[0].imageurl
                    )
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.currentBoNavigationHeadlines[0].header)
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loginHeadlineDialog && !_vm.show2FAPostRegPopup
        ? _c(
            "v-container",
            [
              _c(
                "v-dialog",
                {
                  attrs: { "content-class": "headlines login-headlines" },
                  model: {
                    value: _vm.loginHeadlineDialog,
                    callback: function($$v) {
                      _vm.loginHeadlineDialog = $$v
                    },
                    expression: "loginHeadlineDialog"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "carousel-wrapper" },
                    [
                      _c(
                        "v-carousel",
                        {
                          class: {
                            "single-headline":
                              _vm.currentBoNavigationHeadlines.length === 1
                          },
                          attrs: {
                            interval: _vm.rotationInterval,
                            "hide-delimiters": "",
                            cycle: _vm.cycleRotation
                          }
                        },
                        _vm._l(_vm.loginHeadlines, function(headline, index) {
                          return _c(
                            "v-carousel-item",
                            {
                              key: index,
                              class: [
                                {
                                  active:
                                    headline.idfwheadline ===
                                    _vm.selectedTab.idfwheadline
                                },
                                {
                                  "hover-headline":
                                    typeof headline.location !== "undefined" &&
                                    headline.location !== null
                                }
                              ],
                              on: { notify: _vm.setIndex },
                              nativeOn: {
                                click: function($event) {
                                  return function() {
                                    _vm.goToHeadlineLink(headline)
                                    _vm.sendGTMEventBanner({
                                      headline: headline,
                                      index: index
                                    })
                                    _vm.closeLoginHeadlines()
                                  }.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.mediaServer(headline.imageurl),
                                  alt: headline.body
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "close",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.closeLoginHeadlines()
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "PostLoginAlert" &&
      _vm.postLoginAlerts && _vm.postLoginAlerts.length > 0
        ? _c(
            "v-container",
            { staticClass: "postLoginAlert-headlines", attrs: { fluid: "" } },
            [
              _c("div", { staticClass: "postLoginAlert-headlines--child" }, [
                _c("div"),
                _vm._v(" "),
                _vm.isHeadlineLinkExists(_vm.currentPostLoginAlert)
                  ? _c(
                      "div",
                      {
                        staticClass: "link",
                        on: {
                          click: function($event) {
                            _vm.goToHeadlineLink(_vm.currentPostLoginAlert),
                              _vm.closeCurrentPostLoginAlert(
                                _vm.currentPostLoginAlert.idfwheadline
                              )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.currentPostLoginAlert.bodytext))]
                    )
                  : _c("div", [
                      _vm._v(_vm._s(_vm.currentPostLoginAlert.bodytext))
                    ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.closeCurrentPostLoginAlert(
                          _vm.currentPostLoginAlert.idfwheadline
                        )
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("close")])],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46db9fc9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46db9fc9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/headlinesLight.vue
// module id = null
// module chunks = 